document.querySelectorAll('.HouseItemList__slider').forEach((container) => {
    tns({
        container,
        items: 1,
        slideBy: 1,
        controls: false,
        nav: true,
        mouseDrag: true,
        center: false,
        gutter: 20,
        loop: true,
        responsive: {
            768: {
                items: 3,
                slideBy: 3,
            },
            1200: {
                items: 4,
                slideBy: 4
            },
        }
    });
});

function HouseItemInit(el) {
    if(!el.classList.contains('HouseItem--show')) {
        el.classList.add('HouseItem--show');
        const container = el.querySelector('.HouseItem__slider div');
        const isNav = container.parentElement.hasAttribute('data-slider-nav');
        el.classList.toggle('HouseItem--nav', isNav);
        new SliderControlMouse(container, isNav);
    }
}
document.querySelectorAll('.HouseItem').forEach(HouseItemInit);
